

export default processIds;
import { quote } from '../mappers';
function processIds(ids) {
	return ids.length ? '[' + ids.map(quote).join(', ') + '], ' : '';
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/amd/processIds.js.01-babel.map